<template>
    <BasePanel 
        headline="lang_ERP_SHIPPING_CAPTION_SHIPPING_ROWS"
        >
        <template v-slot:panelContent>
            <v-data-table         
                :headers="headers"
                hide-default-footer
                :items-per-page="990"
                :items="items"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
            >
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                        <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

                <!-- Items -->
                <template v-slot:[`item.connectionObject`]="{ item }">
                    <div v-if="item.connectionId != null" 
                        :alvqa="alvqa + 'list-row-' + item.connectionId + '-product-title'">
                        <BaseIcon  
                            :icon="$alvPlugin.getIconOfType(item.type)" 
                            :tooltipText="$alvPlugin.getIconTooltipText(item)"
                            :alvqa="alvqa + '-icon'"
                        />
                        {{ $alvPlugin.getTitle(item) }}
                    </div>
                    <div v-else :alvqa="alvqa + 'list-row-' + $alvPlugin.getTitle(item).replace(/[^A-Z0-9]+/ig, '-').toLowerCase() + '-freetext'">
                        <BaseIcon  
                            :icon="$alvPlugin.getIconOfType(item.type)" 
                            :tooltipText="$alvPlugin.getIconTooltipText(item)"
                            :alvqa="alvqa + '-icon'"
                        />
                        {{ $alvPlugin.getTitle(item) }}
                    </div>
                </template>

                <template v-slot:[`item.productId`]="{ item }">
                    <div :alvqa="alvqa + 'list-row-' + item.connectionId + '-product-id'">
                        {{ $alvPlugin.getProductItemId(item) }}
                    </div>
                </template>

                <!-- Batch = Charge -->
                <template v-slot:[`item.batch`]="{ item }">
                    <div :alvqa="alvqa + 'list-row-' + item.connectionId + '-batch'">
                        {{ $t(getLangOfBatch(item.batch)) }}
                    </div>
                </template>

                <!-- Quantity with number Integer formatting -->
                <template v-slot:[`item.quantity`]="{ item }">
                    <div :alvqa="alvqa + 'list-row-' + item.connectionId + '-quantity'">
                        {{ $n(item.quantity, 'numberInteger') }}
                    </div>
                </template>

                <!-- Price = Einzelpreis netto -->
                <template v-slot:[`item.price`]="{ item }">
                    <div :alvqa="alvqa + 'list-row-' + item.connectionId + '-price'">
                        <i18n-n v-if="item.price != null" :value=item.price format="number"></i18n-n>
                    </div>
                </template>

                <template slot="body.append">
                    <tr>
                        <td></td>
                        <td></td>
                        <td align="left" class="data-table-sum-row">{{ $t('lang_GENERIC_CAPTION_SUM') }}</td>
                        <td align="right" class="data-table-sum-row">{{ sumField('quantity') }}</td>
                    </tr>
                </template>

            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseIcon from '@/components/_buttons/BaseIcon'
import { DropdownErpShippingBatches } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "ShippingRowsReadOnlyPanel",
    components: {
        BasePanel,
        BaseIcon,
    },
    props:{
        shippingAlvId: {
            type: String
        }
    },
    data() {
        return {
            alvqa: "erp-shipping-list-row-" + this.shippingAlvId + "-read-only-panel-shipping-rows-"
        }
    },
    methods: {
        // sum-up values based on name of the column, e.g. for invoice row Sums of Quantity and Money
        sumField(column) {
            return this.$n(this.items.reduce((a, b) => a + (b[column] || 0), 0), 'numberInteger')
        },
        getLangOfBatch(selection) {
            if (selection) {
                return DropdownErpShippingBatches.find(obj => {
                    return obj.value == selection
                }).text
            } else return ""
        },
        getProductId(item) {
            let id = ""
                if (item.release !== null) { 
                    // first CatalogueNumber, if any, then EAN, if any, standalone or in parantheses (with CatNo)
                    if (item.release.catalogueNumber != null) {
                        id = item.release.catalogueNumber
                        if (item.release.ean != null) id += " (" + item.release.ean + ")"; 
                    } else if (item.release.ean != null) id = item.release.ean
                } else if (item.freeInputId != null) id = item.freeInputId
            return id
            },
    },
    computed: {
        items() { // TODO_PT: do I need the next two rows?
            // this.$store.commit('setIsLoading', true)
            // this.$store.dispatch('fetchShippingShippingRows')
            // return this.$store.getters.getShippingShippingRows 
            let item = this.$store.getters.getExpandedShipping.find(element => {
                return element.alvId === this.shippingAlvId
            })
            let alternativeTitles = item.rows === null ? [] : item.rows
            return alternativeTitles
        },
        headers() {
            return [
                {   text: this.$t('lang_ERP_SHIPPING_CAPTION_ITEM_NAME'), 
                    alvqa: this.alvqa + "header-item-title",
                    align: "left",
                    value: "connectionObject", 
                    sortable: false, 
                    tooltip:"", 
                    class: 'text-no-wrap'},

                {   text: this.$t('lang_GENERIC_CAPTION_ID'), 
                    alvqa: this.alvqa + "header-product-id",
                    align: "left", 
                    value: "productId",
                    sortable: false, 
                    tooltip:"", 
                    class: 'text-no-wrap',
                    width: "270px"},

                {   text: this.$t('lang_ERP_SHIPPING_CAPTION_BATCH'), 
                    alvqa: this.alvqa + "header-batch",
                    align: "left", 
                    sortable: false, 
                    value: "batch", 
                    tooltip:"", 
                    width: "100px"},

                {   text: this.$t('lang_ERP_SHIPPING_CAPTION_QUANTITY'), 
                    alvqa: this.alvqa + "header-quantity",
                    align: "right",
                    sortable: false,
                    value: "quantity",
                    tooltip:"",
                    width: "80px"},

                {   text: this.$t('lang_ERP_SHIPPING_CAPTION_ITEM_PRICE') + ' ' + this.$store.getters.getSelectedCurrency,
                    alvqa: this.alvqa + "header-item-price",
                    align: "right",
                    sortable: false,
                    value: "price",
                    tooltip:"",
                    width: "150px"},
            ]
        },
        itemsPerPage() { return this.$store.getters.getItemsPerPage },
    }
    
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
    }
</style>